import { useEffect } from "react";
import { useLocation } from "react-router-dom";

function DefaultStarValue() {
  const location = useLocation();
  const pathname = location.pathname;
  const avatar = pathname.split("/").pop().toLowerCase();
  const capitalizedAvatar = avatar.charAt(0).toUpperCase() + avatar.slice(1);

  const getDefaultConfigId = (avatar) => {
    switch (avatar) {
      case "mark":
        return "1";
      case "joeie":
        return "3";
      case "dila":
      case "dilla":
        return "5";
      case "hanna":
        return "7";
      default:
        return "";
    }
  };

  const isValidConfigId = (val) => ["1", "3", "5", "7"].includes(val);
  const isValidLanguage = (val) => ["English", "Indonesia"].includes(val);

  useEffect(() => {
    const prevLanguage = sessionStorage.getItem("language");
    const prevConfigId = sessionStorage.getItem("config_id");

    sessionStorage.clear();

    const defaultConfigId = getDefaultConfigId(avatar);

    if (isValidConfigId(prevConfigId)) {
      sessionStorage.setItem("config_id", prevConfigId);
      if (isValidLanguage(prevLanguage)) {
        sessionStorage.setItem("language", prevLanguage);
      } else {
        sessionStorage.setItem("language", "English");
      }
    } else {
      if (defaultConfigId) {
        sessionStorage.setItem("config_id", defaultConfigId);
      }
      sessionStorage.setItem("language", "English");
    }

    if (
      !sessionStorage.getItem("passphrase") &&
      !sessionStorage.getItem("avatar") &&
      !sessionStorage.getItem("topic") &&
      !sessionStorage.getItem("appId")
    ) {
      sessionStorage.setItem("avatar", capitalizedAvatar);

      switch (avatar) {
        case "mark":
          sessionStorage.setItem("passphrase", "$2b$12$q6Nvi.FWjg8JzS1PIPMEKe");
          sessionStorage.setItem("topic", "FXMedia");
          sessionStorage.setItem("appId", "1");
          break;
        case "joeie":
          sessionStorage.setItem("passphrase", "$2b$12$q6Nvi.FWjg8JzS1PIPMEKe");
          sessionStorage.setItem("topic", "FXMedia");
          sessionStorage.setItem("appId", "1");
          break;
        case "dila":
        case "dilla":
          sessionStorage.setItem("passphrase", "$2b$12$q6Nvi.FWjg8JzS1PIPMEKe");
          sessionStorage.setItem("topic", "FXMedia");
          sessionStorage.setItem("appId", "1");
          break;
        case "hanna":
          sessionStorage.setItem("passphrase", "$2b$12$q6Nvi.FWjg8JzS1PIPMEKe");
          sessionStorage.setItem("topic", "FXMedia");
          sessionStorage.setItem("appId", "1");
          break;
        default:
          break;
      }
    }
  }, [avatar, capitalizedAvatar]);

  return null;
}

export default DefaultStarValue;
